<div class="container p-4 bg-white rounded-3" *ngIf="program">
  <h2 class="fw-bold text-theme">Chúc mừng Quý Khách hàng đã đủ tiêu chí tham gia “Gói Đồng hành 2026”!</h2><br />
  <p>“Gói Đồng hành 2026” là cam kết đồng hành và chủ động chịu mọi rủi ro phát sinh của khách hàng trong suốt quá trình kinh doanh thông qua chính sách 
    <b>Bảo hành bất chấp - Đổi trả không cần lý do của Dược Vương</b>,
     giúp Quý Khách hàng an tâm bán hàng và phát triển bền vững.</p>

  <h4 class="fw-bold mt-4">I. Quyền lợi “đồng hành”</h4>
  <ul>
    <li><b>BẢO HÀNH BẤT CHẤP</b> - Đổi trả hàng hóa <strong>KHÔNG CẦN LÝ DO</strong>.</li>
  </ul>

  <h4 class="fw-bold mt-4">II. Điều kiện áp dụng</h4>
  <ul>
    <li>Hàng hóa mua tại <strong>giathuoctot.com</strong> hoặc app <strong>Giathuoctot</strong>, có tem Dược Vương còn
      nguyên vẹn.</li>
    <li>Hàng hóa chưa sử dụng, còn đầy đủ hộp, tem, nhãn mác, không móp méo, rách nát.</li>
  </ul>

  <h4 class="fw-bold mt-4">III. Chi phí vận chuyển</h4>
  <p>Quý Khách hàng vui lòng thanh toán chi phí vận chuyển đổi/trả hàng hóa.</p>

  <h4 class="fw-bold mt-4">IV. Thời hạn áp dụng chương trình</h4>
  <p>Chương trình áp dụng đến hết <strong>{{program.endDate | date: 'dd/MM/yyyy'}}</strong>.</p>

  <h4 class="fw-bold mt-4">V. Hướng dẫn đăng ký</h4>
  <ng-container *ngIf="false">
    <p>
      Quý Khách hàng vui lòng gửi định vị GPS Nhà thuốc của mình, để Dược Vương có thể triển khai các chương trình
      truyền
      thông,
      giúp nhiều Người tiêu dùng đến mua tại Nhà thuốc.
    </p>
    <div class="mb-3">
      <label for="gpsLink" class="form-label fw-bold">Link GPS theo Google Maps:</label>
      <input type="url" id="gpsLink" class="form-control" [(ngModel)]="gpsLink"
        placeholder="Dán link Google Maps vào đây..." />
    </div>

    <div class="form-check mb-3">
      <input type="checkbox" id="agree" class="form-check-input" [(ngModel)]="agreed" />
      <label for="agree" class="form-check-label">
        Tôi đã đọc và đồng ý tham gia <strong>“Gói đồng hành”</strong>
      </label>
    </div>

    <button class="btn btn-regster" [disabled]="!agreed" (click)="registerEvent()" data-cta="companion.register" data-cta-loc="companion">
      <img src="assets/svg/register-event.svg" style="width: 24px; height: 24px;"  loading="lazy" />
      Xác nhận đăng ký
    </button>
  </ng-container>
  <ng-container>
    <p>Bước 1: Quý khách vui lòng copy tin nhắn xác nhận đăng ký “Gói đồng hành 2026” theo nội dung Dược Vương đã soạn bên dưới</p>
    <p>Bước 2: Quý khách mở link <a class="btn-link" target="_blank" href="https://zalo.me/dvmedking">ZaloOA</a> Công ty CPTM Dược Vương, chọn Nhắn tin và gửi nội dung đã copy</p>
    <p><b>Tin nhắn xác nhận đăng ký “Gói Đồng hành 2026”: </b></p>
    <p><b>"{{registerFormat}}"</b>&nbsp;=>&nbsp;Nhấn để copy:&nbsp;<i class="ri-file-copy-line" (click)="copyToClipBoard(registerFormat)"></i></p>
    <br/>
    <div>
      <ul>
        <li>Lưu ý: Sau khi gửi tin nhắn, hệ thống của Dược Vương sẽ ghi nhận thông tin đăng ký và tự động gia hạn trong vòng 24-48h sau khi nhận được tin nhắn xác nhận đăng ký “Gói đồng hành 2026” từ quý khách hàng.</li>
      </ul>
    </div>
  </ng-container>
</div>